var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.words),function(word,index){return _c('span',{key:index,staticClass:"rounded-md",class:{ 'bg-orange': _vm.isWordActive(index) }},[_vm._v(" "+_vm._s(word)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }